module.exports = __webpack_public_path__ + "img/tradein3.b0d5d880.jpg";